export const COOKIE_CONSENT_STORAGE_KEY = 'cookie-consent'
export const COOKIE_CONSENT_UPDATED_AT_KEY = 'cookie-consent-updated-at'
export const COOKIE_CONSENT_VERSION_KEY = 'cookie-consent-version'
export const COOKIE_CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365
export const COOKIE_CONSENT_VERSION = 'v1'

export const cookieConsentValues = ['accepted', 'declined'] as const
export type CookieConsentValue = (typeof cookieConsentValues)[number]
export type CookieConsentStatus = CookieConsentValue | 'unset'

export function isCookieConsentValue(value: string): value is CookieConsentValue {
    return cookieConsentValues.includes(value as CookieConsentValue)
}

export function toCookieConsentStatus(value: string | undefined): CookieConsentStatus {
    if (!value) {
        return 'unset'
    }

    return isCookieConsentValue(value) ? value : 'unset'
}

export function getCookieConsentCookieString(value: CookieConsentValue): string {
    return `${COOKIE_CONSENT_STORAGE_KEY}=${value}; path=/; max-age=${COOKIE_CONSENT_MAX_AGE_SECONDS}; SameSite=Lax`
}

export function getCookieConsentMetaCookieStrings(timestamp: string): string[] {
    return [
        `${COOKIE_CONSENT_UPDATED_AT_KEY}=${timestamp}; path=/; max-age=${COOKIE_CONSENT_MAX_AGE_SECONDS}; SameSite=Lax`,
        `${COOKIE_CONSENT_VERSION_KEY}=${COOKIE_CONSENT_VERSION}; path=/; max-age=${COOKIE_CONSENT_MAX_AGE_SECONDS}; SameSite=Lax`,
    ]
}
